<template>
  <div class="landing-cnt row">
    <div class="bg-image"></div>
    <div class="col-12 d-xl-none d-lg-flex main-block-xs"></div>
    <!-- Main text block not logged -->
    <div class="text-block-ctn col-xl-6 col-12 d-flex my-auto">
      <div class="text-ctn my-auto">
        <h1 v-if="!hideTitle" v-html="$t('openlegal.title')"></h1>
        <h3>{{ title }}</h3>
        <!-- <p>
          {{ $t('text-1')}}
        </p> -->
        <div class="btn-cnt">
          <base-button class="mt-5" white shadow @click="$helpers.goToSection('contact-form')">{{ $t('more-info')}}</base-button>
          <base-button class="mt-5" shadow @click="$helpers.goToSection('contact-form')" :backgroundColor="GRAY_COLOUR" :textColor="WHITE_COLOUR" :borderColor="WHITE_COLOUR">{{ $t('openlegal.menu.sign-in') }}</base-button>
        </div>
      </div>
    </div>
    <div class="learn-more" @click="$helpers.goToSection('contact-form')" v-if="!$store.getters['session/isLogged']">
      <span>{{ $t('openlegal.more-info') }}</span>
    </div>
    </div>
</template>

<script>
import { GRAY_COLOUR, WHITE_COLOUR } from '@/constants/colours'

export default {
  data () {
    return {
      GRAY_COLOUR,
      WHITE_COLOUR
    }
  },
  props: {
    title: {
      type: String,
      required: false,
      default () {
        return this.$t('openlegal.subtitle')
      }
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalMainBlock.vue